module.exports = __webpack_public_path__ + "static/img/2.513d1dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/2.png
// module id = Ch0F
// module chunks = 0